import classNames from 'classnames';

import type { ChangeEvent, TextareaHTMLAttributes } from 'react';

type TextareaProps = {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  className?: string;
  minHeight?: string;
  wrapperClassName?: string;
} & Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  'value' | 'onChange' | 'className'
>;

export const Textarea = ({
  value,
  onChange,
  placeholder,
  className,
  minHeight = 'min-h-[200px]',
  wrapperClassName,
  ...props
}: TextareaProps) => (
  <div
    className={classNames(
      'overflow-hidden rounded-[12px] border border-solid border-[#afc4d1] flex items-center justify-center p-[4px]',
      wrapperClassName,
    )}
  >
    <textarea
      className={classNames(
        'w-full resize-y px-[20px] py-[16px] outline-none',
        minHeight,
        className,
      )}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
    />
  </div>
);
